import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateUnitType } from '@shared/enums';

@Component({
  selector: 'app-duration-toggle',
  templateUrl: './duration-toggle.component.html',
  styleUrls: ['./duration-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DurationToggleComponent),
      multi: true,
    },
  ],
})
export class DurationToggleComponent implements ControlValueAccessor, OnInit {
  @Input() options: any;
  @Input() min: Date;
  @Input() max = new Date();
  @Input() ExcludeFromEnum: string[] = [];

  readonly latestYearsCount = 4;
  readonly years: number[] = Array.from({ length: this.latestYearsCount }, (_, i) => new Date().getFullYear() - i);
  selectedYear: number = this.years[0];

  selectedOptions: string[] = [];

  dateUnitType: DateUnitType;
  selectedDate: Date;
  weeklyDateDisplay: string;

  protected DateUnitType = DateUnitType;

  ngOnInit(): void {
    this.selectedOptions = this.objectKeys(this.options);
  }

  onChange = (value: { dateUnitType: DateUnitType; selectedDate: Date }) => {};
  onTouched = () => {};

  writeValue(value: { dateUnitType: DateUnitType; selectedDate: Date }): void {
    this.dateUnitType = value.dateUnitType;
    this.selectedDate = value.selectedDate;
    this.updateDisplay();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  onDateUnitChange(value: DateUnitType): void {
    this.dateUnitType = value;
    this.selectedDate = this.dateUnitType === DateUnitType.Yearly ? new Date(this.selectedYear, 0, 1) : new Date();
    this.onChange({ selectedDate: this.selectedDate, dateUnitType: value });
    this.onTouched();
    this.updateDisplay();
  }

  onDateChange(value: Date): void {
    this.onChange({ selectedDate: this.dateUnitType === DateUnitType.Yearly ? new Date(Number(value), 0, 1) : value, dateUnitType: this.dateUnitType });
    this.onTouched();
    this.updateDisplay();
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj).filter((key) => !this.ExcludeFromEnum.includes(this.options[key]));
  }

  updateDisplay(): void {
    if (this.dateUnitType === 'WEEKLY') {
      this.generateWeeklyDate();
    }
  }

  generateWeeklyDate(): void {
    const today = new Date();
    const lastWeek = new Date();
    lastWeek.setDate(today.getDate() - 7);

    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
    };
    const lastWeekStr = new Intl.DateTimeFormat('en-US', options).format(lastWeek);

    this.weeklyDateDisplay = `${lastWeekStr} : Today`;
  }
}
